export enum DataType {
    JSON = 'JSON'
}
